export const duvalCityCoords = {
  jacksonville: { coords: [-81.6557, 30.3322], hybridZoom: 11, normalZoom: 10 },
  atlantic_beach: { coords: [-81.648, 30.3354], hybridZoom: 10, normalZoom: 9 },
  jacksonville_beach: {
    coords: [-81.648, 30.3354],
    hybridZoom: 10,
    normalZoom: 9,
  },
  neptune_beach: { coords: [-81.648, 30.3354], hybridZoom: 10, normalZoom: 9 },
  duval: { coords: [-81.648, 30.3354], hybridZoom: 10, normalZoom: 9 },
};
